import DOMPurify from 'dompurify'

// Sanitize user-generated HTML before it is rendered with `v-html`.
// Keeps safe formatting (links, line breaks, tables, basic markup) but strips
// dangerous content such as <script>, inline event handlers (onerror, onclick)
// and javascript: URLs. Prevents stored XSS on publicly reachable pages.
export function sanitizeHtml(dirty) {
  if (dirty == null) return dirty
  return DOMPurify.sanitize(String(dirty))
}

export default sanitizeHtml
